import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class QuarterOfYearRangeRequest {
  @observable
  from!: string;

  @observable
  to!: string;
}

export const QuarterOfYearValidationRules: EntityValidationRules<QuarterOfYearRangeRequest> = {
  from: {
    required: true,
  },
  to: {
    required: true,
    isAfterQuarterYear: {
      condition: (entity: QuarterOfYearRangeRequest) => entity.from,
    },
  },
};
